import React, { useState } from 'react';
import ArticleCard from '../components/ArticleCard';
import { useAdminAuth } from '../../../context/AdminAuthContext';
import { API_BASE_URL } from '../scripts/control';
import ImageCrop from "../components/ImageCrop";


const Articles = () => {
    const { isAdmin } = useAdminAuth();
    const [showModal, setShowModal] = useState(false);
    const [showConfirmCloseModal, setShowConfirmCloseModal] = useState(false);
    const [showCropModal, setShowCropModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);   // imagen original (DataURL)
    const [croppedImage, setCroppedImage] = useState(null); 

    const handleCreateNew = () => {
        setShowModal(true);
    };

    const handleSaveModal = async () => {
        const formData = new FormData();
        const title = document.getElementById('title').value;
        const body = document.getElementById('body').value;
        const imgFile = document.getElementById('img_url').files[0];
        const imgAlt = document.getElementById('img_alt').value;
        const day = document.getElementById('day').value;
        const hour = document.getElementById('hour').value;
        const location = document.getElementById('location').value;

        formData.append('title', title);
        formData.append('body', body);
        formData.append('day', day);
        formData.append('hour', hour);
        formData.append('location', location);
        formData.append('img_alt', imgAlt);

        const inputFile = document.getElementById('img_url');
        const file = inputFile.files[0];
        if (croppedImage) {
              formData.append('img_url', croppedImage);
            } else if (file) {
              // si no hemos recortado, usamos el file original
              formData.append('img_file', file);
        }


        try {
            const response = await fetch(`${API_BASE_URL}/api/article_func.php`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Error al guardar el artículo');
            }

            const result = await response.json();
            if (result.success) {
                alert('Artículo guardado con éxito');
            } else {
                alert('Error al guardar el artículo: ' + result.message);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setShowModal(false);
        }
        window.location.reload();
    };

    const handleCloseModal = () => {
        setShowConfirmCloseModal(true);
    };

    const handleConfirmClose = () => { // Seguridad para no perder datos
        setShowModal(false);
        setShowConfirmCloseModal(false);
    };

    const handleCancelClose = () => {
        setShowConfirmCloseModal(false);
        setSelectedImage(null);
        setCroppedImage(null);
    };

    const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
      reader.onload = () => {
        setSelectedImage(reader.result); // guardamos la imagen en el estado
        setShowCropModal(true);         // modal de crop
      };
      reader.readAsDataURL(file);
    };

    const handleCropSave = (cropped) => {
      // 'cropped' es la imagen recortada en DataURL
      setCroppedImage(cropped);
      setShowCropModal(false);
    };

    return (
        <div>
            <h2 className = "title">Divulgación y Transferencia</h2>
            <hr className="small-hr"></hr><br />
            {isAdmin && (
                <>
                    <button onClick={handleCreateNew} 
                        style={{ marginBottom: '20px', marginLeft: '25%', padding: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px' }}>
                        Crear nuevo artículo
                    </button>

                    {showModal && (
                        <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Crear nuevo artículo</h5>
                                        <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseModal}></button>
                                    </div>
                                    <div className="modal-body">
                                        <form>
                                            <label htmlFor="title">Título del artículo:</label><br />
                                            <input type="text" id="title" name="title" /><br />
                                            <label htmlFor="body">Texto principal:</label><br />
                                            <textarea rows="8" cols="35"  id="body" name="body"></textarea><br />
                                            <label htmlFor="img_url">Imagen del artículo:</label><br />
                                            <input
                                              type="file"
                                              id="img_url"
                                              name="img_url"
                                              accept="image/*"
                                              onChange={handleImageUpload}
                                            />
                                            {/* Previsualización de la imagen */}
                                            {croppedImage ? (
                                              <div>
                                                <p>Previsualización (Imagen recortada):</p>
                                                <img
                                                  src={croppedImage}
                                                  alt="Imagen recortada"
                                                  style={{ maxWidth: '100%' }}
                                                />
                                              </div>
                                            ) : selectedImage ? (
                                              <div>
                                                <p>Previsualización (Sin recortar):</p>
                                                <img
                                                  src={selectedImage}
                                                  alt="Imagen seleccionada"
                                                  style={{ maxWidth: '100%' }}
                                                />
                                              </div>
                                            ) : null}
                                            <br /><br />
                                            <label htmlFor="img_alt">Texto alternativo de la imagen:</label>
                                            <small> Necesario para personas con discapacidad visual.</small><br />
                                            <input type="text" id="img_alt" name="img_alt"/><br />
                                            <hr />
                                            <small>Rellenar a continuación para permitir agendar con Google Calendar:</small><br />
                                            <label htmlFor="day">Día del evento:</label><br />
                                            <small>Se ordenará por este parámetro.</small><br />
                                            <input type="date" id="day" name="day" /><br />
                                            <label htmlFor="hour">Hora de inicio del evento:</label><br />
                                            <input type="time" id="hour" name="hour" /><br /><br />
                                            <label htmlFor="location">Lugar del evento:</label><br />
                                            <small>Es importante incluir aquí detalles como número de la calle y cp, para que google maps pueda localizarlo.</small><br />
                                            <textarea rows="2" cols="35"   id="location" name="location"></textarea><br />                 
                                        </form> 
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>Cancelar</button>
                                        <button type="button" className="btn btn-primary" onClick={handleSaveModal}>Guardar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {showConfirmCloseModal && (
                        <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Confirmar cierre</h5>
                                        <button type="button" className="btn-close" aria-label="Close" onClick={handleCancelClose}></button>
                                    </div>
                                    <div className="modal-body">
                                        <p>¿Quieres abandonar la creación? Se perderán los cambios no guardados.</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-secondary" onClick={handleCancelClose}>Volver</button>
                                        <button type="button" className="btn btn-primary" onClick={handleConfirmClose}>Salir</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
            <ArticleCard isAdmin={isAdmin} />
            {/* Modal de Crop: se abrirá cuando subamos una imagen */}
            {showCropModal && (
              <div className="modal show" style={{ display: 'block' }} tabIndex="-1">
                <div className="modal-dialog" style={{ maxWidth: '80%' }}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Recortar imagen</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setShowCropModal(false)}
                      ></button>
                    </div>
                    <div className="modal-body">
                      <ImageCrop image={selectedImage} onImageSave={handleCropSave} />
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
    );
};

export default Articles ;
